import { render } from "./form12.vue?vue&type=template&id=3bb79723&scoped=true"
import script from "./form12.vue?vue&type=script&lang=js"
export * from "./form12.vue?vue&type=script&lang=js"

import "./form12.vue?vue&type=style&index=0&id=3bb79723&scoped=true&lang=less"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb79723"]])

export default __exports__